import { createContext, useContext } from 'react';

export const CampaignsTableContext = createContext({
  switchToTab: () => {},
  highlightCampaign: () => {},
  highlightedCampaignUuid: null,
  clearStatusFilters: () => {},
  setStatusFilters: () => {},
});

export const useCampaignsTableContext = () => useContext(CampaignsTableContext);
